import script from "./user-product-launch.vue?vue&type=script&setup=true&lang=js"
export * from "./user-product-launch.vue?vue&type=script&setup=true&lang=js"

import "./user-product-launch.vue?vue&type=style&index=0&id=6c59f180&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c59f180"]])

export default __exports__